import React, { useState, useEffect, useRef } from "react";
import {
  Toolbar,
  Typography,
  Button,
  TextField,
  InputAdornment,
  CssBaseline,
  IconButton,
  MenuItem,
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Box,
} from "@mui/material";
import KeyboardOutlinedIcon from '@mui/icons-material/KeyboardOutlined';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import CloseIcon from "@mui/icons-material/Close";
import LogoutIcon from "@mui/icons-material/Logout";
import ExitToAppOutlinedIcon from '@mui/icons-material/ExitToAppOutlined';
import AccountCircle from "@mui/icons-material/AccountCircle";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import AssessmentIcon from "@mui/icons-material/Assessment";
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import LibraryAddIcon from '@mui/icons-material/LibraryAdd';
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import MenuIcon from "@mui/icons-material/Menu";
import Footer from "../components/Footer";
import ItemView from "../components/ItemsView";
import ScannedSold from "../components/ScannedSold";
import ManualSold from "../components/ManualSold";
import SoldHistory from "../components/SoldHistory";
import Reports from "../components/Reports";
import Bill from "../components/GenerateBill";
import CreateItem from "../components/CreateItem"
import GolbalView from "../components/GobalView"
import Payment from "../components/Payment";
import SkeletonLoader from "../components/SkeletonLoader";
import { useLocation, useNavigate } from "react-router-dom";
import { useUser } from "../context/UserContext";
import { AppBarStyled } from "../styles/theme";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import "bootstrap/dist/css/bootstrap.min.css";
import { resetPassword } from "../services/api";
import { ToastContainer, toast } from "react-toastify";
import CategoryIcon from '@mui/icons-material/Category';
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import Customer from "../components/Customer";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';
import BusinessIcon from '@mui/icons-material/Business';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LockResetIcon from '@mui/icons-material/LockReset';
import { Outlet } from "react-router-dom";



const HomePage = () => {
  const { user } = useUser();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [content, setContent] = useState("Stocks");
  const [logoutModalOpen, setLogoutModalOpen] = useState(false);
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [forgotPasswordOpen, setForgotPasswordOpen] = useState(false);
  const [resetPasswordOpen, setResetPasswordOpen] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [salesMenuOpen, setSalesMenuOpen] = useState(false); // New state for Sales menu
  const [profilePicture, setProfilePicture] = useState(user.profilePicture);
  const [clickedProfile, setClickedProfile] = useState(false);
  const fileInputRef = useRef(null);
  const location = useLocation();



  const toggleNewPasswordVisibility = () => setShowNewPassword((prev) => !prev);
  const toggleConfirmPasswordVisibility = () =>
    setShowConfirmPassword((prev) => !prev);

  const toggleDrawer = () => {
    setDrawerOpen((prev) => !prev); // Only affects sidebar
  };

  const [selectedItem, setSelectedItem] = useState("Stocks");

  const handleMenuClick = (item, isSubMenu = false) => {
    if (item === "Sales" && !isSubMenu) {
      setSalesMenuOpen(!salesMenuOpen);
      return;
    }

    if (selectedItem !== item) {
      setSelectedItem(item);
    }

    // Convert item names to lowercase with hyphens for URLs
    const formattedPath = item.toLowerCase().replace(/\s+/g, "-");
    console.log(formattedPath);
    navigate(`/beverages/${formattedPath}`);

    if (isMobile) {
      setDrawerOpen(false);
    }
  };

  useEffect(() => {
    const path = location.pathname.replace("/", "").replace(/-/g, " ");
    const pathParts = path.split("/"); 
    const lastPart = pathParts[pathParts.length - 1];
  
    // Capitalize each word in the extracted menu item
    const formattedText = lastPart
      .split(" ")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  
    if (path) {
      setContent(path.charAt(0).toUpperCase() + path.slice(1)); // Capitalize first letter
      console.log(path.charAt(0).toUpperCase() + path.slice(1));
      setSelectedItem(formattedText);
      console.log(formattedText); 
    }
  }, [location]);
  

  //logout method
  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  // Handle profile picture change
  const handleProfilePictureChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      // For demonstration, log the file name
      console.log(file.name);
      // After successful upload, update the profile picture state
      setProfilePicture(URL.createObjectURL(file));
    }
  };

  const handleProfileClick = () => {
    setClickedProfile(true); // Hide the icon and show file input
    fileInputRef.current.click();
  }


  useEffect(() => {
    if (user.role === "admin") {

      setContent("Users");
    }
  }, [user])

  useEffect(() => {
    const fetchData = async () => {
      setTimeout(() => {
        // setLoading(false);
      }, 1000);
    };
    fetchData();
  }, [content]);


  const menuItems = [
    { text: "Users", icon: <GroupAddIcon />, roles: ["admin"] },
    { text: "Payments", icon: <CurrencyRupeeIcon />, roles: ["admin"] },
    { text: "Brands", icon: <LibraryAddIcon />, roles: ["owner"] },
    { text: "Bills", icon: <ReceiptLongIcon />, roles: ["owner"] },
    { text: "Global Item Details", icon: <CategoryIcon />, roles: ["owner"] },
    { text: "Stocks", icon: <Inventory2Icon />, roles: ["owner", "worker"] },
    { text: "Stock Reports", icon: <AssessmentIcon />, roles: ["owner"] },
    {
      text: "Sales",
      icon: <ShoppingCartIcon />,
      roles: ["owner", "worker"],
      subMenus: [
        { text: "Manually", icon: <KeyboardOutlinedIcon />, roles: ["owner", "worker"] },
        { text: "Scanner", icon: <QrCodeScannerIcon />, roles: ["owner", "worker"] },
      ],
    },
    {
      text: "Sales History",
      icon: <ShoppingBagIcon />,
      roles: ["owner", "worker"],
    },
  ];


  // Filter menu items based on user role
  const filteredMenuItems = menuItems.filter((item) =>
    item.roles.includes(user.role)
  );

  // password reset method
  const handleResetPassword = async () => {
    const verifyUserId = user.userId;
    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match.");
      return;
    }
    try {
      const response = await resetPassword({ verifyUserId, newPassword });
      if (response.status === 200) {
        toast.success("Password Changed successfully!");
        setResetPasswordOpen(false);
        setNewPassword("");
        setConfirmPassword("");
      } else {
        toast.error("Failed to reset password. Try again.");
      }
    } catch (error) {
      toast.error("Error resetting password.");
    }
  };

  const ResetPassword = () => {
    setNewPassword("");
    setConfirmPassword("");
  }

  return (
    <>
      <CssBaseline />
      <ToastContainer />
      <div className="d-flex min-vh-100 flex-column">
        {/* Header */}
        <AppBarStyled position="fixed">
          <Toolbar className={`col-12 ${isMobile ? "px-2" : ""}`} style={{ minHeight: isMobile ? "56px" : "64px" }}>
            <IconButton edge="start" color="inherit" aria-label="menu" onClick={toggleDrawer} className="me-2">
              {drawerOpen ? <CloseIcon /> : <MenuIcon />}
            </IconButton>
            <Typography variant="h6" component="div" className="flex-grow-1" style={{ fontSize: isMobile ? "1rem" : "1.25rem" }}>
              Beverage Inventory and Sales Management
            </Typography>
            {!isMobile && `Hello, ${user.orgName}`}
            <MenuItem sx={{ borderRadius: 10 }}>
              <AccountCircle className="ms-2" onClick={() => setForgotPasswordOpen(true)} />
            </MenuItem>
            <IconButton color="inherit" onClick={() => setLogoutModalOpen(true)}>
              <LogoutIcon />
            </IconButton>
          </Toolbar>
        </AppBarStyled>



        {/* Main Content with Sidebar */}
        <div className="d-flex" style={{ marginTop: isMobile ? "56px" : "64px", height: "calc(100vh - 120px)" }}>

          {/* Sidebar */}
          <div
            className="sidebar"
            style={{
              width: drawerOpen ? "250px" : "0",
              backgroundColor: "#0B192C",
              color: "white",
              overflowY: "auto",
              transition: "width 0.2s",
              flexShrink: 0, // Prevents sidebar from shrinking
            }}
          >
            <Drawer
              variant={isMobile ? "temporary" : "persistent"}
              anchor="left"
              open={drawerOpen}
              onClose={isMobile ? toggleDrawer : undefined} // Only close on mobile
              sx={{
                "& .MuiDrawer-paper": {
                  width: 250,
                  backgroundColor: "#0B192C",
                  color: "white",
                  mt: isMobile ? "56px" : "64px",
                },
              }}
            >
              <List>
                {filteredMenuItems.map((item) => (
                  <React.Fragment key={item.text}>

                    <ListItemButton
                      onClick={() => handleMenuClick(item.text)}
                      sx={{
                        backgroundColor: selectedItem === item.text ? "#35374B" : "transparent",
                        "&:hover": { backgroundColor: "#373A40" },
                        borderRadius: "8px",
                      }}
                    >
                      <ListItemIcon sx={{ color: "white" }}>{item.icon}</ListItemIcon>
                      <ListItemText primary={item.text} />

                      {/* Show ExpandLessIcon if menu is open, otherwise ExpandMoreIcon */}
                      {item.text === "Sales" && (salesMenuOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />)}
                    </ListItemButton>



                    {item.text === "Sales" && salesMenuOpen && item.subMenus?.map((sub) => (

                      <ListItemButton
                        key={sub.text}
                        onClick={() => handleMenuClick(sub.text, true)}
                        sx={{
                          paddingLeft: "32px",
                          backgroundColor: selectedItem === sub.text ? "#3E4050" : "transparent",
                          "&:hover": { backgroundColor: "#424453" },
                          borderRadius: "8px",
                        }}
                      >
                        <ListItemIcon sx={{ color: "white" }}>{sub.icon}</ListItemIcon>
                        <ListItemText primary={sub.text} />

                      </ListItemButton>
                    ))}
                  </React.Fragment>
                ))}
              </List>

            </Drawer>


          </div>

          {/* Content */}
          <div
            className="content p-4"
            style={{
              flexGrow: 1, // Allow content to grow and occupy remaining space
              width: "100%",
              transition: "all 0.3s",

            }}
          >
            <Outlet />
            <div className="container-fluid">
              {content === "Bills" && <Bill />}
              {content === "Brands" && <CreateItem />}
              {content === "Stocks" && <ItemView />}
              {content === "Manually" && <ManualSold />}
              {content === "Scanner" && <ScannedSold />}
              {content === "Stock Reports" && <Reports />}
              {content === "Sales History" && <SoldHistory />}
              {content === "Global Item Details" && <GolbalView />}
              {content === "Users" && <Customer />}
              {content === "Payments" && <Payment />}
            </div>
          </div>
        </div>


      </div>
      <div>
        <Footer className="mt-auto" />
      </div>
      {/* Logout Modal */}
      <Dialog open={logoutModalOpen} onClose={() => setLogoutModalOpen(false)} sx={{ borderRadius: "10px" }}>
        <DialogTitle sx={{ color: "#EB8317" }}><ExitToAppOutlinedIcon sx={{ marginRight: "20px" }} />Logout Confirmation</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ marginLeft: "20px", color: "#0C134F" }}>
            Are you sure you want to log out?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ padding: "0px 20px 20px 0px", margin: "10px 0px 0px 200px ", }}>
          <Button variant="outlined" onClick={() => setLogoutModalOpen(false)} sx={{ textTransform: "none" }}>
            Cancel
          </Button>
          <Button variant="contained" onClick={handleLogout} color="error" sx={{ textTransform: "none" }}>
            Logout
          </Button>
        </DialogActions>
      </Dialog>

      {/* Profile Details Modal */}

      <Dialog
        open={forgotPasswordOpen}
        onClose={() => setForgotPasswordOpen(false)}
        maxWidth="xs"
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "12px",
            boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.1)",
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            backgroundColor: "#394867",
            color: "white",
            borderRadius: "12px 12px 0 0",
            padding: "16px 24px",
          }}
        >
          <Typography variant="h5" sx={{ fontWeight: 600 }}>
            User Profile
          </Typography>
          <IconButton
            edge="end"
            color="inherit"
            onClick={() => setForgotPasswordOpen(false)}
            aria-label="close"
          >
            <CloseIcon sx={{ color: "white" }} />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ padding: "24px", marginTop: 3 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 3,
              marginBottom: 3,
              position: "relative", // Make the container position relative to allow absolute positioning of the icon
              "&:hover .edit-icon": {
                visibility: clickedProfile ? "hidden" : "visible", // Hide icon after profile click
              },
            }}
          >
            <Avatar
              alt={user.userName}
              src={profilePicture}
              sx={{ width: 72, height: 72, bgcolor: "#EBEAFF" }}
              onClick={handleProfileClick} // Handle click on profile picture
            />
            <Box>
              <Typography variant="h6" sx={{ fontWeight: 500 }}>
                {user.userName}
              </Typography>
              <Typography variant="body2" sx={{ color: "text.secondary" }}>
                Role: {user.role}
              </Typography>

            </Box>

            <input
              ref={fileInputRef}
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              onChange={handleProfilePictureChange}
            />
          </Box>

          <Divider sx={{ marginY: 3 }} />

          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <BusinessIcon sx={{ color: "text.secondary" }} />
              <Typography variant="body1">
                <strong>Organization ID:</strong> {user.orgId}
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <EmailIcon sx={{ color: "text.secondary" }} />
              <Typography variant="body1">
                <strong>Email:</strong> {user.email}
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <PhoneIcon sx={{ color: "text.secondary" }} />
              <Typography variant="body1">
                <strong>Phone:</strong> {user.phone}
              </Typography>
            </Box>
          </Box>

          <Button
            onClick={() => setResetPasswordOpen(true)}
            sx={{
              backgroundColor: "#EBEAFF",
              color: "black",
              fontWeight: 500,
              marginTop: 2,
              width: "100%",
              padding: "10px",
              borderRadius: "8px",
            }}
          >
            <LockResetIcon /> Reset Password
          </Button>
        </DialogContent>
      </Dialog>

      {/* Change Password Modal */}

      <Dialog
        open={resetPasswordOpen}
        onClose={() => setResetPasswordOpen(false)}
        PaperProps={{
          sx: {
            width: "450px",
            margin: "auto",
            borderRadius: "8px",
          },
        }}
      >
        <DialogTitle color="primary">Change Password</DialogTitle>
        <IconButton
          onClick={() => setResetPasswordOpen(false)}
          sx={{ position: "absolute", top: 8, right: 8 }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <TextField
            label="New Password"
            fullWidth
            type={showNewPassword ? "text" : "password"}
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            size="small"
            margin="normal"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={toggleNewPasswordVisibility} edge="end">
                    {showNewPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <TextField
            label="Confirm Password"
            fullWidth
            type={showConfirmPassword ? "text" : "password"}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            size="small"
            margin="normal"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={toggleConfirmPasswordVisibility}
                    edge="end"
                  >
                    {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </DialogContent>
        <DialogActions sx={{ margin: "0px 15px 10px 0px" }}>
          <Button variant="contained" sx={{ textTransform: "none", background: "#ED3EF7", color: "white" }} onClick={() => ResetPassword()}>Rest</Button>
          <Button variant="contained" sx={{ textTransform: "none" }} onClick={handleResetPassword} color="primary">
            Set Password
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default HomePage;
